import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { DriverFilters, DriverSlice } from "./driversTypes.ts";

const initialState: DriverSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "lastName",
    order: "asc",
  },
};

export const driversSlice = createSlice({
  name: "drivers",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<DriverSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<DriverSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof DriverFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<DriverSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  driversSlice.actions;

export const selectPage = (state: RootState) => state.drivers.page;
export const selectRowsPerPage = (state: RootState) =>
  state.drivers.rowsPerPage;
export const selectFilter = (state: RootState) => state.drivers.filter;
export const selectSort = (state: RootState) => state.drivers.sort;

export default driversSlice.reducer;
